import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App'; // Importing the App component
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { initEmailJS } from './services/emailjs';

// Initialize EmailJS
initEmailJS();

const container = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// The build step pre-renders each route into static HTML; hydrate that markup instead of replacing it.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app, { onRecoverableError: () => undefined });
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
